import type { CityConfig } from "../city-template/types";

export const kirkwoodMOConfig: CityConfig = {
  city: "Kirkwood",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "kirkwood-mo",
  route: "/cities/kirkwood-mo",
  title: "Emergency Passport Kirkwood, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kirkwood, MO — as fast as 24 hours. Serving southwest St. Louis County. A+ BBB rated registered State Dept. courier serving Kirkwood train station commuters and the I-44 corridor. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Kirkwood, MO",
  heroSubtitle: "Southwest St. Louis County business trip to Amsterdam on short notice? Meramec River Valley family vacation to Costa Rica with expired passports? Amtrak commuter heading to Europe needs fast documents? We help Kirkwood residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20Kirkwood%20Missouri%20downtown%20train%20station%20Amtrak%20commuter%20rail%20platform%20tree-lined%20streets%20boutique%20shops%20red%20brick%20buildings%20St%20Louis%20County%20suburb%20autumn%20golden%20foliage%20warm%20afternoon%20light%20professional%20photography&width=1800&height=700&seq=kirkwood-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Historic Kirkwood Missouri downtown with Amtrak train station and tree-lined streets",
  geoPosition: "38.5834;-90.4068",
  geoPlacename: "Kirkwood, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 295 miles northeast of Kirkwood via I-55",
  },
  nearbyCitiesZips: [
    { name: "Kirkwood", zips: "63122" },
    { name: "Webster Groves", zips: "63119" },
    { name: "Des Peres", zips: "63131" },
    { name: "Crestwood", zips: "63126" },
    { name: "Sunset Hills", zips: "63127" },
    { name: "Glendale", zips: "63122" },
    { name: "Oakland", zips: "63122" },
    { name: "Warson Woods", zips: "63122" },
    { name: "Grantwood Village", zips: "63123" },
    { name: "Ladue", zips: "63124" },
    { name: "Brentwood", zips: "63144" },
    { name: "Affton", zips: "63123" },
    { name: "Shrewsbury", zips: "63119" },
    { name: "Maplewood", zips: "63143" },
    { name: "Town and Country", zips: "63017" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent St. Louis County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southwest St. Louis County", desc: "Serving Kirkwood, Webster Groves, Des Peres, and the I-44 corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Fast passport renewal in Chesterfield, MO", route: "/cities/chesterfield-mo" },
    { name: "Emergency passport help in St. Charles, MO", route: "/cities/st-charles" },
    { name: "Urgent passport services in Florissant, MO", route: "/cities/florissant-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Columbia, MO", route: "/cities/columbia-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kirkwood remotely via secure courier. We do not have a walk-in office in Kirkwood — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for southwest St. Louis County.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of southwest St. Louis County including Webster Groves, Des Peres, Crestwood, and communities along the I-44 corridor",
  serviceAreaIntro: "From the historic Kirkwood train station and the charming downtown district with its boutique shops and restaurants to the residential neighborhoods of Webster Groves and its tree-lined streets, from the retail hub of Des Peres and West County Center to the quiet subdivisions of Glendale and Warson Woods — Fast Passport Center serves the entire southwest St. Louis County region. We regularly help travelers from Kirkwood, Webster Groves, and surrounding communities get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Kirkwood neighborhoods and the surrounding southwest St. Louis County area including Webster Groves, Des Peres, Crestwood, Sunset Hills, Glendale, and Ladue. If you are anywhere along the I-44 corridor in St. Louis County, we have you covered.",
  howItWorksIntro: "Most Kirkwood travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Kirkwood travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Kirkwood and southwest St. Louis County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Kirkwood? Here are the most common ones we hear from St. Louis County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (MO DHSS)", url: "https://health.mo.gov/data/vitalrecords/", desc: "Missouri Department of Health & Senior Services for birth and death certificates statewide" },
    { label: "Marriage Licenses (St. Louis County Recorder)", url: "https://www.stlouiscountymo.gov/", desc: "St. Louis County Recorder of Deeds for Kirkwood and St. Louis County" },
    { label: "Divorce Decrees (St. Louis County Circuit Court)", url: "https://www.courts.mo.gov/", desc: "St. Louis County Circuit Court for Kirkwood and St. Louis County" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Missouri vital records online via VitalChek" },
  ],
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kirkwood travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "Kirkwood, MO",
      rating: 5,
      text: "Had a Paris anniversary trip booked and my husband's passport was expired with 3 days to go. Fast Passport Center got it renewed in 29 hours. We made our flight! From Kirkwood to the Eiffel Tower — incredible.",
      service: "Passport Renewal",
    },
    {
      name: "Tom B.",
      location: "Webster Groves, MO",
      rating: 5,
      text: "Emergency business trip to Tokyo with 4 days notice. Fast Passport Center handled my entire application. The dedicated agent called me twice with updates. Got my passport in 36 hours. Unmatched service.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel D.",
      location: "Des Peres, MO",
      rating: 5,
      text: "Both my teenagers needed first passports for a school trip to Costa Rica. Fast Passport Center walked us through the child process and got both in 4 days. Saved our trip and my sanity!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "kirkwood-1",
      name: "Kirkwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "343 S Kirkwood Rd",
      city: "Kirkwood",
      state: "MO",
      zip: "63122",
      phone: "(314) 966-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Kirkwood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kirkwood facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "kirkwood-2",
      name: "St. Louis County — Government Center",
      type: "County Government Passport Acceptance",
      address: "41 S Central Ave",
      city: "Clayton",
      state: "MO",
      zip: "63105",
      phone: "(314) 615-7038",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "7 miles northeast of Kirkwood",
      website: "https://www.stlouiscountymo.gov",
      websiteLabel: "St. Louis County Recorder",
      notes: "Accepts passport applications at county seat. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "kirkwood-3",
      name: "Webster Groves Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17 S Elm Ave",
      city: "Webster Groves",
      state: "MO",
      zip: "63119",
      phone: "(314) 962-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles east of Kirkwood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Webster Groves and eastern Kirkwood area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "kirkwood-4",
      name: "Crestwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9819 Watson Rd",
      city: "Crestwood",
      state: "MO",
      zip: "63126",
      phone: "(314) 849-6111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Kirkwood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Crestwood and southern Kirkwood area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "kirkwood-5",
      name: "Des Peres Government Center",
      type: "City Hall Passport Acceptance",
      address: "12325 Manchester Rd",
      city: "Des Peres",
      state: "MO",
      zip: "63131",
      phone: "(314) 835-6100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "4 miles west of Kirkwood",
      website: "https://www.desperesmo.org",
      websiteLabel: "City of Des Peres",
      notes: "Accepts passport applications at Des Peres City Hall. Appointment recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Kirkwood photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at St. Louis County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Kirkwood applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many St. Louis County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Kirkwood travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Kirkwood." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kirkwood address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Kirkwood before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Kirkwood for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Kirkwood?", a: "Fast Passport Center offers fast passport renewal in Kirkwood in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Kirkwood?", a: "The nearest regional passport agency to Kirkwood is the Chicago Passport Agency, approximately 295 miles northeast via I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Kirkwood without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Kirkwood?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Kirkwood — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for St. Louis County residents." },
    { q: "Do you serve the entire southwest St. Louis County area?", a: "Absolutely. Fast Passport Center serves all of southwest St. Louis County including Kirkwood, Webster Groves, Des Peres, Crestwood, Sunset Hills, Glendale, and surrounding areas. Our courier service works seamlessly from any address along the I-44 corridor." },
    { q: "Can I expedite a child passport in Kirkwood?", a: "Yes. Fast Passport Center expedites child passports in Kirkwood for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk St. Louis County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Kirkwood with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Kirkwood", address: "1200 S Kirkwood Rd, Kirkwood, MO 63122", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Kirkwood", address: "10445 Manchester Rd, Kirkwood, MO 63122", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Webster Groves", address: "8590 Big Bend Blvd, Webster Groves, MO 63119", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Target — Brentwood", address: "25 Brentwood Promenade Ct, Brentwood, MO 63144", hours: "Mon–Sat: 8AM–10PM, Sun: 8AM–9PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — South County License Office",
      address: "4542 Lemay Ferry Rd, St. Louis, MO 63129",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Maplewood License Office",
      address: "7401 Manchester Rd, Maplewood, MO 63143",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Maplewood, Brentwood, and central county. REAL ID available.",
      featured: false,
    },
    {
      name: "Missouri DOR — Chesterfield License Office",
      address: "15272 Manchester Rd, Ballwin, MO 63011",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Ballwin and western St. Louis County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "18 miles north of Kirkwood",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with direct flights worldwide. About 25 minutes from Kirkwood via I-170/I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: true,
    },
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "120 miles west of Kirkwood",
      address: "11300 S Airport Dr, Columbia, MO 65201",
      note: "Regional airport with direct flights to major hubs. About 2 hours from Kirkwood via I-70.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: false,
    },
    {
      code: "SPI",
      name: "Abraham Lincoln Capital Airport",
      distance: "110 miles northeast of Kirkwood",
      address: "1200 Capital Airport Dr, Springfield, IL 62707",
      note: "Regional airport serving Springfield, IL. About 1 hour 50 minutes from Kirkwood via I-55.",
      flightUrl: "https://www.flyspi.com/",
      flightLabel: "SPI Airport",
      featured: false,
    },
  ],
};